var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('Porfolio2',{attrs:{"product":_vm.product}}),_c('b-row',[_c('b-col',{attrs:{"md":"6"}}),_c('b-col',{attrs:{"md":"6"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }